// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function swipePower(offset: any, absDistance: any) {
  return (offset / absDistance) * 100
}
